import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

type TUseDeleteGoalChallengeMutation = {
  challengeId: string;
  focusAreaId?: string;
  options?: any;
};

export const useDeleteGoalBreakdownChallengeMutation__DEPRECATED = ({
  challengeId,
  focusAreaId,
  options,
}: TUseDeleteGoalChallengeMutation) => {
  const { goalId } = useParams();
  const { request } = useMutationHTTPRequest();

  return useMutation(
    () =>
      request({
        url: `/api/web/goals/${goalId}/breakdown/challenges/remove`,
        body: focusAreaId ? { challengeId, focusAreaId } : { challengeId },
      }),
    {
      ...options,
    }
  );
};
